import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { squishTableName } from '../../utils/on-site';

interface Props {
  name: string;
  className?: string;
}

/** "Table 7" with "Table" muted, or "Terrace 2" as it is (the rule of utils/on-site formatTableName). */
export default function TableName({ name, className }: Props) {
  const { t } = useTranslation(null, { keyPrefix: 'Components:OrderType:TableOrdering' });
  const squished = squishTableName(name);

  return (
    <span className={classnames('truncate min-w-0', className)} data-test="table-name">
      {/^\d/.test(squished) && <span className="text-muted-foreground font-normal">{t('table')} </span>}
      <b className="font-bold text-brand-text-primary">{squished}</b>
    </span>
  );
}
